module.exports = __webpack_public_path__ + "static/images/close.3735d62.png";